// extracted by mini-css-extract-plugin
module.exports = {"wallet_model":"styles_wallet_model__xa5mR","text":"styles_text___eEdj","wallet__btns":"styles_wallet__btns__fq8Ol","btn":"styles_btn__89AHa"};